var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "tab-body",
        {
          ref: _vm.name,
          style: { color: _vm.color },
          attrs: {
            id: "tab-" + _vm.name,
            active: _vm.active,
            name: _vm.name,
            "aria-label": _vm.$t(_vm.a11y.key, { name: _vm.name }),
            "aria-selected": _vm.active,
            background: _vm.background,
            "data-test": "tab",
            tabindex: "1"
          }
        },
        [
          _c(
            "div",
            { staticClass: "relative overflow-hidden" },
            [_vm._t("default")],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }